/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

var _excluded = ["children", "className"];
var CardLabeledRows = function CardLabeledRows(_ref) {
  var children = _ref.children,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement("div", _extends({}, rest, {
      className: classnames('cpc--card__labeled-rows', className)
    }), children)
  );
};
CardLabeledRows.propTypes = {
  /**
   * A className to apply to the CardLabeledRows component.
   */
  className: PropTypes.string,
  /**
   * The children to render in the CardLabeledRows component. Any element whose index is odd will
   * be rendered as a label. Any element whose index is even will be rendered as a value for that
   * label.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired
};
var CardLabeledRows$1 = CardLabeledRows;

export { CardLabeledRows$1 as default };
